import { animated, SpringValue, SpringValues } from '@react-spring/web';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BlockRenderElement, Rect } from '../types';
import { SectionThumbnail } from '../components/section-thumbnail';
import { SectionThumbnailNew } from '../components/section-thumbnail-new';

const THUMBNAIL_LAYOUT = {
  width: 56,
  height: 42,
  contentPadding: 2,
};

type PlayerSectionCardProps = {
  id: string;
  index: number;
  title: string;
  current: boolean;
  blockRenderElements: BlockRenderElement[];
  showIndices: boolean;
  expandedFraction: SpringValue<number>;
  sectionDrawerOpen: boolean;
  style: SpringValues<{ y: number }>;
  rect: Rect;
  onCardClick: () => void;
};

export const NeuePlayerSectionCardNew = React.forwardRef<HTMLDivElement, PlayerSectionCardProps>(
  (
    {
      id,
      index,
      title,
      current,
      blockRenderElements,
      showIndices,
      style,
      rect,
      expandedFraction,
      sectionDrawerOpen,
      onCardClick,
    }: PlayerSectionCardProps,
    ref
  ) => {
    return (
      <div className='absolute w-0 h-0'>
        <animated.div
          className={classNames(
            'group/player-section-bar pl-6 absolute flex gap-1 items-center transition-opacity cursor-pointer'
          )}
          style={{
            transform: style.y.to((y) => `translate3d(${rect.x}px, ${y}px, 0)`),
            width: `${rect.width}px`,
            height: `${rect.height}px`,
          }}
          onClick={onCardClick}
          ref={ref}
        >
          {/* <div className='shrink-0 w-6 h-full top-0 left-0 flex items-center justify-center'>
            <div
              className={classNames('text-bedrock-p-small-strong transition', {
                'opacity-100': showIndices,
                'opacity-0': !showIndices,
                'text-neue-canvas-fg': current,
                'text-neue-canvas-fg-50 group-hover/player-section-bar:text-neue-canvas-fg': !current,
              })}
            >
              {index + 1}
            </div>
          </div> */}
          <div className='flex flex-1 gap-2 items-center'>
            <div
              className={classNames('handle transition-opacity', {
                'opacity-100': current,
                'opacity-70 group-hover/player-section-bar:opacity-100': !current,
              })}
            >
              <SectionThumbnailNew
                thumbnailLayout={THUMBNAIL_LAYOUT}
                blockRenderElements={blockRenderElements}
                layoutMode='web'
                className={classNames({ 'cursor-pointer': true })}
                current={current}
              />
            </div>
            <animated.div
              className={classNames('flex flex-1 relative', {
                'pointer-events-none': !sectionDrawerOpen,
              })}
              style={{
                opacity: expandedFraction.to((fraction) => fraction),
                transform: expandedFraction.to((fraction) => `translateX(-${(1 - fraction) * 8}px)`),
              }}
            >
              <div
                className={classNames(
                  'flex-1 text-neue-journey-medium-strong line-clamp-2 transition bg-transparent min-w-0',
                  'cursor-pointer text-neue-canvas-fg',
                  {
                    'opacity-100': current,
                    'opacity-70 group-hover/player-section-bar:opacity-100': !current,
                  }
                )}
              >
                {title || 'Untitled'}
              </div>
            </animated.div>
          </div>
        </animated.div>
      </div>
    );
  }
);
